import { FC, memo } from 'react';
import { Link } from 'react-router';
import { Button } from '@chakra-ui/react';

import { useEditDetails } from './hooks/useEditDetails';
import { EditDetailsProps } from './types/EditDetailsProps';

const EditDetailsComponent: FC<EditDetailsProps> = ({
  title,
  blockId,
  documentType,
}) => {
  const { editLink, scrollToTop } = useEditDetails(
    title,
    blockId,
    documentType,
  );

  if (!editLink) {
    return null;
  }

  return (
    <Button asChild borderColor="gray.200" ml={2} variant="outline">
      <Link onClick={scrollToTop} to={editLink}>
        Edit Details
      </Link>
    </Button>
  );
};

export const EditDetails = memo(EditDetailsComponent);
